export interface IGatewayPaymentUrl {
  gatewayReferenceId: string;
  movementId: string;
  gatewayTransactionId?: string;
  gatewayPaymentUrl: string;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export class GatewayPaymentUrl {
  gatewayReferenceId: string;
  movementId: string;
  gatewayTransactionId?: string;
  gatewayPaymentUrl: string;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IGatewayPaymentUrl) {
    this.gatewayReferenceId = data.gatewayReferenceId;
    this.movementId = data.movementId;
    this.gatewayTransactionId = data.gatewayTransactionId;
    this.gatewayPaymentUrl = data.gatewayPaymentUrl;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
